export default "__VITE_ASSET__BFugrNRZ__"